import React from 'react';
import ReactDOM from 'react-dom/client';
import { lazy, Suspense } from 'react';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { StoreProvider } from './store/store';
import { ThemeProvider, Spinner } from '@material-tailwind/react';
import { PasswordModalProvider } from './context/PasswordModalContext';
import ConsolePage from './routes/app/developer/ConsolePage';
import ChannelLayout from './routes/app/ChannelLayout';
import ChannelsRedirect from './components/ChannelsRedirect';

const LandingPage = React.lazy(() => import('./routes/LandingPage'));
const LoginPage = React.lazy(() => import('./routes/LoginPage'));
const RegisterPage = React.lazy(() => import('./routes/RegisterPage'));
const AppLayout = React.lazy(() => import('./routes/app/AppLayout'));
const StagingPage = React.lazy(() => import('./routes/app/developer/StagingPage'));
const InboxPage = React.lazy(() => import('./routes/app/InboxPage'));
const ChannelsPage = React.lazy(() => import('./routes/app/ChannelsPage'));
const ThemeManagerPage = React.lazy(() => import('./routes/app/developer/ThemeManagerPage'));
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <PasswordModalProvider>
        <BrowserRouter>
          <StoreProvider>
            <Suspense
              fallback={
                <div className="fixed inset-0 flex items-center justify-center z-[9999] bg-[#0F1217]">
                  <Spinner
                    className="w-4 h-4 text-[#989bff]"
                    onResize={undefined}
                    onResizeCapture={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                  />
                </div>
              }
            >
              <Routes>
                <Route key={'LandingPage'} path="/" index element={<LandingPage />} />
                <Route key={'LoginPage'} path={'login'} element={<LoginPage />} />
                <Route key={'RegisterPage'} path={'register'} element={<RegisterPage />} />
                <Route path="/channels" element={<AppLayout />}>
                  <Route index element={<ChannelsRedirect />} />
                  <Route path={'home'} element={<InboxPage />} />
                  <Route
                    path={'@me/:channel'}
                    key={'DMsPageWithParam'}
                    element={<ChannelsPage />}
                  />
                  <Route path={'@me'} key={'DMsPage'} element={<ChannelsPage />} />
                  <Route
                    path={'/channels/@me/developer'}
                    key={'StaggingPage'}
                    element={<StagingPage />}
                  />
                  <Route
                    path={'/channels/@me/theme'}
                    key={'ThemeManagerPage'}
                    element={<ThemeManagerPage />}
                  />
                  <Route
                    path={'/channels/@me/console'}
                    key={'ConsolePage'}
                    element={<ConsolePage />}
                  />
                  <Route
                    path={'/channels/:server/:channel'}
                    key={'ChannelLayout'}
                    element={<ChannelLayout />}
                  />
                  <Route
                    path={':server/:channel'}
                    key={'ChannelsPageWithParam'}
                    element={<ChannelsPage />}
                  />
                </Route>
              </Routes>
            </Suspense>
          </StoreProvider>
        </BrowserRouter>
      </PasswordModalProvider>
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
